import Icon from 'veui/components/Icon'
import { IconPaintBucket } from 'dls-icons-vue'

Icon.register('paint-bucket', IconPaintBucket)
